
import { Image } from 'utils'
import { TYPE } from 'network/server_tool'
import { Animation } from 'animation'
import { REQUEST_TYPE } from 'network/net'
import { symbol_index_to_pos, is_cheque, destroy } from './table'

import {to_literal_text} from'./ui_view';
import {getMinorUnitText} from'./abstract';

export default function( space, container, spec, settings )
{
    const view = new PIXI.Container
    view.position.set( 174, 0 )
    container.addChild( view )
    view.interactiveChildren = false
    
    //balls and wins:
    const balls_view = Image( settings.smallTicket.balls_screen )
    view.addChild( balls_view )
    space.s( 'sportbet:balls_visible' )
        .any(space.s( 'sportbet:table_mode' ), (v, isTable) => v && !isTable)
        .on( v => balls_view.visible = v )
    const balls = []
    const circles = []
    const BALL_X = 64
    const BALL_Y = 36
    const BALL_D_X = 27
    const BALL_D_Y = 18

    for (let line = 0; line < spec.specification.linesCountMax; ++line) {
        let lineSpec = spec.specification.linesPaths[line];
        let circleLine = [];
        for (let col = 0; col < 5; ++col) {
            let row = lineSpec[col];
            let circle = Image( settings.smallTicket.miniballsNameFormat.$( line ) );
            circle.visible = false;
            circleLine.push( circle )
            circle.position.set( BALL_X + col * BALL_D_X - 7, BALL_Y + row * BALL_D_Y - 3 );
            balls_view.addChild( circle )
        }
        circles.push(circleLine);

    }

    let scatterCircles = [];
    for (let col = 0; col < 5; ++col) {
        let circle = Image( settings.smallTicket.scatterBallName );
        circle.visible = false;
        scatterCircles.push( circle )
        circle.position.set( BALL_X + col * BALL_D_X - 7, BALL_Y );
        balls_view.addChild( circle )
    }

    for (let b = 0; b < 15; ++b) {
        const pos = symbol_index_to_pos( b )
        let ball = new PIXI.extras.BitmapText('', { font : 'small_ticket_digits', align: "center" });
        ball.anchor.set(0.5, 0.0);
        balls.push( ball );
        ball.position.set( BALL_X + pos.col * BALL_D_X, BALL_Y + pos.row * BALL_D_Y );
        balls_view.addChild( ball );
    }

    let risk_balls = [];
    risk_balls.push(Image('res/games/risk/red_ball.png'));
    risk_balls.push(Image('res/games/risk/black_ball.png'));
    risk_balls.forEach(b => {
        b.position.set(94, 38);
        b.visible = false;
        balls_view.addChild(b);
    })

    let winLabel = new PIXI.Text(
        '',
        {
            fontSize : 14,
            fill : 0xfefb00,
            align : 'center',
            fontWeight : 'bold',
        },
    );
    winLabel.anchor.set(0.5, 0.5);
    winLabel.position.set(120, 109);
    balls_view.addChild(winLabel);

    const isRiskState = (state) => {
        return state &&
            state.type &&
            ([ TYPE.RISK_MAIN, TYPE.RISK_RESULT, TYPE.RISK_RESULT_RED, TYPE.RISK_RESULT_BLACK ].includes( state.type ))
    };

    const showTableSymbol = (symbols) => {
        balls.forEach((b, id) => {
            b.text = symbols[id];
        });
        for (let ci of circles) {
            ci.forEach(c => c.visible = false);
        }
        scatterCircles.forEach(sc => sc.visible = false);

        risk_balls.forEach(b => b.visible = false);

        winLabel.text = '';
    };

    const showTableRisk = (color, win) => {
        balls.forEach((b, id) => {
            b.text = '';
        });
        for (let ci of circles) {
            ci.forEach(c => c.visible = false);
        }
        scatterCircles.forEach(sc => sc.visible = false);

        risk_balls[color].visible = true;
        risk_balls[1-color].visible = false;

        winLabel.text = getMinorUnitText(win, space);
    };

    space.s( 'sportbet:balls_visible' ).next( false )
    space.s( 'sportbet:balls_rolled' )
        .map(() => true)
        .to( space.s( 'sportbet:balls_visible' ) )
    space.s( 'pending' )
        .filter( p => p == REQUEST_TYPE.SPIN )
        .map(() => false)
        .to(space.s( 'sportbet:balls_visible' ));
    space.s( 'state' )
        .any( space.s( 'sportbet:balls_visible' ), ( state, v ) => ({ state, v }) )
        .filter( ({ v }) => v )
        .map( ({ state }) => state )
        .filter(state => !isRiskState(state))
        .with(space.s('balance'), (state, balance) => ({state, balance}))
        .on( ({state, balance}) => {
            let math = state.state.stage.math
            if (math && math.symbols) {
                showTableSymbol(state.state.stage.math.symbols);
                if (state.state.stage.win) {
                    winLabel.text = to_literal_text(state.state.stage.win, balance);
                }
            }
        });
    space.s( 'pending' )
        .filter( p => p == REQUEST_TYPE.SPIN )
        .on( () => {
            balls.forEach((b, id) => {
                b.text = '';
            });
            for (let ci of circles) {
                ci.forEach(c => c.visible = false);
            }
            scatterCircles.forEach(sc => sc.visible = false);
        } );

    space.s( 'presenter:play_line' )
        .with( space.s( 'math' ), ( lo, math ) => ({ line : math.winLines()[ lo ], math }) )
        .filter(({line}) => line !== undefined)
        .on( ({ line, math }) => {

            for (let id = 0; id < circles.length; ++id) {
                circles[id].forEach(c => c.visible = false);
            }
            scatterCircles.forEach(sc => sc.visible = false);
            const win_pos = math.lineWinPositions( line );
            for ( let i = 0; i < win_pos.length; ++i ) {
                let wp = win_pos[i];
                const pos = symbol_index_to_pos( wp );
                let c = circles[line][i];
                c.position.set( BALL_X + pos.col * BALL_D_X - 7, BALL_Y + pos.row * BALL_D_Y - 3 )
                c.visible = true;
            }

        } );

    space.s( 'presenter:play_scatters' )
        .filter(play => play)
        .with( space.s( 'math' ), ( scatter, math ) => math )
        .on(math => {
            for (let id = 0; id < circles.length; ++id) {
                circles[id].forEach(c => c.visible = false);
            }
            scatterCircles.forEach(sc => sc.visible = false);

            const win_pos = math.scatterPositions();
            for ( let i = 0; i < win_pos.length; ++i ) {
                let wp = win_pos[i];
                const pos = symbol_index_to_pos( wp );
                let c = scatterCircles[i];
                c.position.set( BALL_X + pos.col * BALL_D_X - 7, BALL_Y + pos.row * BALL_D_Y - 3 )
                c.visible = true;
            }
        });
    
    //lines choice:
    if ( settings.smallTicket.lines_choice ) {
        const lines_view = new PIXI.Container
        view.addChild( lines_view )
        space.s( 'state' )
            .any( space.s( 'sportbet:balls_visible' ), ( state, bv ) => ({ type : state.type, bv }) )
            .map( ({ type, bv }) => ( type == TYPE.FINAL || type == TYPE.REGULAR ) && ! bv )
            .on( v => lines_view.visible = v )
        const groups = []
        for ( let i = 0; i < spec.lines_array.length; ++ i ) {
            const l = Image( settings.smallTicket.lines_choice.$( i + 1 ) );
            groups.push( l )
            lines_view.addChild( l )
        }
        space.s( 'ui:resultBet' )
            //скрываем в табличном режиме
            .any(space.s( 'sportbet:table_mode' ), ({ bet }, isTable) => ({bet, isTable}))
            .on( ({ bet, isTable }) => {
                for ( let i = 0; i < spec.lines_array.length; ++ i ) {
                    groups[ i ].visible = (i <= bet.lines) && !isTable;
                }
            } );
    }

    const risk_view = new PIXI.Container();
    let risk_screens = [];
    for (let i = 0; i < 2; ++i) {
        const risk_screen = Image( settings.smallTicket.risk_template.$( i ) );
        risk_view.addChild(risk_screen);
        risk_screens.push(risk_screen);
    }

    view.addChild(risk_view);

    space.s( 'state' )
        .any( space.s( 'sportbet:table_mode' ), ( state, tm ) => ({ type : state.type, tm }) )
        .map(({ type, tm }) => ( type == TYPE.RISK_MAIN ) && ! tm)
        .on(v => {
            risk_view.visible = v
        });

    space.s('risk: current_blink_card').on(card => {
        risk_screens[card].visible = true;
        risk_screens[1 - card].visible = false;
    })

    space.s( 'risk:result' ).on( ({ state, result }) => {
        //console.log('RES', result);
        let color = (result.currentWin > 0) ? result.playerChoise : 1 - result.playerChoise;
        showTableRisk(color, result.currentWin);
    });
}










// WEBPACK FOOTER //
// ./src/games/small_ticket.es6